module.exports = __webpack_public_path__ + "media/images/icon-calendar-white-ad50f0b4.svg";